var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6571 3.43464C26.5336 0.188452 21.4596 0.188452 18.3228 3.43464L16.9998 4.81223L15.6768 3.43464C12.5534 0.188452 7.47929 0.188452 4.34258 3.43464C1.21914 6.68084 1.21914 11.9318 4.34258 15.1784L16.9727 28.2861L17 28.2588L17.0273 28.2861L29.6574 15.1784C32.7809 11.9322 32.7809 6.6812 29.6574 3.43464H29.6571Z",
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5476 5.52887C24.9447 2.82371 20.7163 2.82371 18.1024 5.52887L16.9998 6.67686L15.8973 5.52887C13.2945 2.82371 9.06608 2.82371 6.45215 5.52887C3.84928 8.23403 3.84928 12.6099 6.45215 15.3153L16.9773 26.2384L17 26.2157L17.0227 26.2384L27.5479 15.3153C30.1507 12.6102 30.1507 8.23433 27.5479 5.52887H27.5476Z",
    fill: "#9B7BD0",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.438 7.6231C23.3557 5.45897 19.973 5.45897 17.8819 7.6231L16.9999 8.54149L16.1179 7.6231C14.0356 5.45897 10.6529 5.45897 8.56172 7.6231C6.47943 9.78722 6.47943 13.2879 8.56172 15.4523L16.9818 24.1907L17 24.1726L17.0182 24.1907L25.4383 15.4523C27.5206 13.2881 27.5206 9.78747 25.4383 7.6231H25.438Z",
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3285 9.71732C21.7668 8.09423 19.2298 8.09423 17.6614 9.71732L16.9999 10.4061L16.3384 9.71732C14.7767 8.09423 12.2396 8.09423 10.6713 9.71732C9.10957 11.3404 9.10957 13.9659 10.6713 15.5892L16.9864 22.1431L17 22.1294L17.0136 22.1431L23.3287 15.5892C24.8904 13.9661 24.8902 11.3406 23.3285 9.71732Z",
    fill: "#5A8C8D",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4179 11.4871C20.3119 10.3376 18.5153 10.3376 17.4046 11.4871L16.9362 11.9748L16.4677 11.4871C15.3618 10.3376 13.5651 10.3376 12.4545 11.4871C11.3485 12.6365 11.3485 14.4958 12.4545 15.6453L16.9266 20.2866L16.9363 20.2769L16.9459 20.2866L21.418 15.6453C22.524 14.4959 22.5239 12.6366 21.4179 11.4871Z",
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9393 12.9531C19.1977 12.1824 17.9931 12.1824 17.2484 12.9531L16.9343 13.2801L16.6201 12.9531C15.8786 12.1824 14.6739 12.1824 13.9292 12.9531C13.1877 13.7238 13.1877 14.9704 13.9292 15.7412L16.9278 18.8532L16.9343 18.8467L16.9408 18.8532L19.9394 15.7412C20.6809 14.9705 20.6808 13.7238 19.9393 12.9531Z",
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4646 14.419C18.0874 14.027 17.4747 14.027 17.096 14.419L16.9362 14.5853L16.7765 14.419C16.3993 14.027 15.7866 14.027 15.4079 14.419C15.0307 14.811 15.0307 15.445 15.4079 15.837L16.933 17.4198L16.9362 17.4165L16.9395 17.4198L18.4646 15.837C18.8418 15.4451 18.8417 14.811 18.4646 14.419Z",
    fill: "#5A8C8D",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.c5045dce9630ec3e9538bb0dc66c1d26.svg";
export { ForwardRef as ReactComponent };